import { useEffect } from 'react';
import { useLocation } from 'history-slice/selectors';
import { useHistoryApi } from 'history-slice/actions';
const Router = ({ defaultRoute, routes = [] }) => {
  const location = useLocation();
  const { replace } = useHistoryApi();
  const defaultRoutePath = defaultRoute?.path;
  const firstRoutePath = routes.at(0)?.path;
  useEffect(() => {
    if (defaultRoutePath || firstRoutePath) {
      replace(defaultRoutePath || firstRoutePath);
    }
  }, [replace, defaultRoutePath, firstRoutePath]);
  const page = routes.find(
    ({ path }) =>
      path === location.pathname ||
      (location.pathname === '/' && path === location.hash),
  );
  return page ? <page.Component /> : null;
};

export default Router;
